import { MappingValues } from 'src/app/services/dtos/mapping-values';
import { MappingForm } from 'src/app/services/dtos/MappingForm';
import { CopyMappingForm } from 'src/app/services/dtos/copyMappingForm';
import { RuleForm } from 'src/app/services/dtos/ruleForm';

export class FetchAllMappings {
  public static readonly type = '[Mapping] Fetch All';
  public constructor(public customerId: string) {}
}

export class FetchMapping {
  public static readonly type = '[Mappings] Fetch mapping';
  public constructor(public id: string, public withValues: boolean) {}
}

export class SetCurrentMappingId {
  public static readonly type = '[Mappings] Set Current Mapping Id';
  public constructor(public id: string) {}
}

export class ClearCurrentMappingId {
  public static readonly type = '[Mappings] Clear Current Mapping Id';
}

export class AddMapping {
  public static readonly type = '[Mappings] Add';
  public constructor(public payload: MappingForm) {}
}

export class UpdateMapping {
  public static readonly type = '[Mappings] Update';
  public constructor(public payload: MappingForm) {}
}

export class DeleteMapping {
  public static readonly type = '[Mapping] Delete';
  public constructor(public mappingId: string) {}
}

export class CopyMapping {
  public static readonly type = '[Mappings] Copy';
  public constructor(public payload: CopyMappingForm) {}
}

export class UpdateMappingValues {
  public static readonly type = '[Mappings] Update values';
  public constructor(public payload: MappingValues) {}
}

export class AddRule {
  public static readonly type = '[Mapping] Add rule';
  public constructor(public payload: RuleForm, public customerId: string) {}
}

export class EditRule {
  public static readonly type = '[Mapping] Edit rule';
  public constructor(public payload: RuleForm, public customerId: string) {}
}

export class SetCurrentRuleId {
  public static readonly type = '[Mappings] Set Current Rule Id';
  public constructor(public id: string) {}
}

export class ClearCurrentRuleId {
  public static readonly type = '[Mappings] Clear Current Rule Id';
}

export class DeleteRule {
  public static readonly type = '[Mapping] Delete rule';
  public constructor(public ruleId: string, public customerId: string) {}
}

export class SetActivePluginId {
  public static readonly type = '[Mappings] Set Active Plugin Id';
  public constructor(public id: string) {}
}

export class ClearActivePluginId {
  public static readonly type = '[Mappings] Clear Active Plugin Id';
}

export class SetCustomerMappingIds {
  public static readonly type = '[Mapping] Set Customer mapping ids';
  public constructor(public mappingIds: string[]) {}
}

